import { render, staticRenderFns } from "./ManagePatientNotes.vue?vue&type=template&id=53736b36"
import script from "./ManagePatientNotes.vue?vue&type=script&lang=js"
export * from "./ManagePatientNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports